import React from "react";

const PhoneSolidIcon = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 15 14"
      className={className ? className : "w-[15px] h-[14px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M13.345 9.19a8 8 0 0 1-2.496-.398c-.39-.134-.871-.011-1.11.234l-1.574 1.188c-1.825-.974-2.95-2.099-3.911-3.91L5.407 4.77c.3-.299.407-.736.279-1.146a8 8 0 0 1-.4-2.5C5.287.503 4.784 0 4.164 0h-2.57C.972 0 .468.504.468 1.123.469 8.223 6.245 14 13.345 14c.62 0 1.124-.504 1.124-1.123v-2.564c0-.62-.504-1.124-1.124-1.124"
      ></path>
    </svg>
  );
};

export default PhoneSolidIcon;
